import { render, staticRenderFns } from "./OrderAccount.vue?vue&type=template&id=2a6b207f&scoped=true"
import script from "./OrderAccount.vue?vue&type=script&lang=ts"
export * from "./OrderAccount.vue?vue&type=script&lang=ts"
import style0 from "./OrderAccount.vue?vue&type=style&index=0&id=2a6b207f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b207f",
  null
  
)

export default component.exports